/* Coincidencias: mismas reglas tolerantes del buscador existente, sin otra lista. */
window.VelantisBusqueda=window.VelantisBusqueda||(function(){
 function norm(s){return String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]/g,'');}
 function distance(a,b){var d=[],i,j;for(i=0;i<=a.length;i++)d[i]=[i];for(j=1;j<=b.length;j++)d[0][j]=j;for(i=1;i<=a.length;i++)for(j=1;j<=b.length;j++){d[i][j]=Math.min(d[i-1][j]+1,d[i][j-1]+1,d[i-1][j-1]+(a[i-1]===b[j-1]?0:1));if(i>1&&j>1&&a[i-1]===b[j-2]&&a[i-2]===b[j-1])d[i][j]=Math.min(d[i][j],d[i-2][j-2]+1);}return d[a.length][b.length];}
 function score(q,value){var n=norm(value);if(!q||!n)return 0;if(n===q)return 1000;if(n.indexOf(q)===0)return 900;if(n.indexOf(q)>=0)return 800;if(q.length<4)return 0;var max=Math.min(3,Math.floor(q.length*.28));if(Math.abs(n.length-q.length)>max)return 0;var d=distance(q,n);return d<=max?600-d*50:0;}
 function match(query,item){
  var q=norm(query),sku=norm(item.sku),name=item.nombre||'',house=item.casa||'',text=norm(item.texto||'');if(!q)return 0;
  if(/^v\d+$/.test(q)){q='v'+q.slice(1).padStart(3,'0');return sku===q?1100:sku.indexOf(q)===0?900:0;}
  var s=Math.max(score(q,name),Math.round(score(q,house)*.9));
  if(text.indexOf(q)>=0)s=Math.max(s,700);
  var words=String(query).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().split(/\s+/).map(norm).filter(Boolean);
  if(words.length>1&&words.every(function(w){return text.indexOf(w)>=0;}))s=Math.max(s,650);
  return s;
 }
 return {normalizar:norm,puntuar:score,coincidencia:match};
})();
/* Ficha de producto Velantis · generado por construir_plantilla.py — no editar a mano */

(function(){

  'use strict';

  var pg = document.querySelector('.pagina[data-datos]'); if(!pg) return;

  var P = JSON.parse(document.getElementById('ficha-producto').textContent);

  var BASE = pg.dataset.assets, PISO = 1200, WA = '5216629375124';

  var VISTA = /[?&]view=ficha\b/.test(location.search) ? '?view=ficha' : '';

  function pesos(n){ return '$' + Math.round(Number(n)).toLocaleString('en-US'); }

  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  function $(s, r){ return (r || pg).querySelector(s); }

  function $$(s, r){ return [].slice.call((r || pg).querySelectorAll(s)); }



  /* ------------------------------------------------ precios y textos del servidor */

  $$('[data-precio].t-precio').forEach(function(e){ e.textContent = pesos(e.dataset.precio); });

  $$('.pp-tl').forEach(function(b){

    var z = $('.t-porml', b), m = /(\d+)\s*(ml|l)\b/i.exec(b.dataset.et || '');

    if(z && m){ var ml = +m[1] * (m[2].toLowerCase() === 'l' ? 1000 : 1); z.textContent = '$' + (b.dataset.precio / ml).toFixed(2) + ' el ml'; }

  });

  var d = $('.ficha-desc');

  if(d){

    var t = d.textContent.replace(/^¿A qué huele[^?]*\?\s*/i, '').split(/\s*Notas aromáticas/i)[0]

      .replace(/Ideal para Ideal para/g, 'Ideal para').replace(/[^.]*feromona[^.]*\.?/gi, '').trim();

    d.textContent = t;

    if(!t) d.remove();

  }



  /* ------------------------------------------------ el carrito: el UNICO del sitio (15-sep-2026)

     La casa quiso este cajón en todo el sitio y conectado al de la portada. Ahora vive en

     assets/carrito.js (SITIO-WEB/CARRITO) y lo cargan las dos páginas: mismas piezas, mismas

     promociones, mismo enlace de pago. Aquí solo quedan los puentes de la ficha. */

  var PAQUETE = {"aromatizante": "Paquete Santal 33", "aroVar": "51378918949088", "regalo": "SANTAL 33", "regaloVar": "54656243433696", "codigo": "PAQUETE-SANTAL33", "obsequio": "Elixir de Parfum 30 ml · Santal 33", "subObsequio": "Obsequio de la casa · Paquete Santal 33"};

  function VC(){ return window.__VC; }

  var DATOS_F = null;                                   /* catalogo compacto (lo llena el fetch de abajo) */

  /* cuántos frascos ganaría una selección (lo usan las bandas «Arma tu paquete» y layering) */

  function regalo(ls){

    var n100 = 0, n50 = 0;

    ls.forEach(function(l){ if(l.tipo === 'perfume'){ if(l.tl === '50') n50 += l.qty; else if(l.tl === '100') n100 += l.qty; } });

    return {n100: n100, n50: n50, ganados: (window.VELANTIS_OFFERS && window.VELANTIS_OFFERS.gift30Enabled === true) ? Math.floor(n100 / 2) + Math.floor(n50 / 3) : 0};

  }

  function lineaEnvio(total){ var f = (((VC()||{}).envios||{}).umbralGratis || 999) - total; return f <= 0 ? '<b>Envío gratis incluido.</b>' : 'Faltan <b>' + pesos(f) + '</b> para el envío gratis.'; }

  function sumar(item, tl, qty){

    var o = item.op[tl]; if(!o || !o[1] || !VC()) return false;

    VC().addVariante(o[1], {nombre: item.nombre, precio: o[0], et: o[2], qty: qty || 1, abrir: false});

    return true;

  }

  function restarVar(v){ if(VC()) VC().restarVariante(v); }

  function abrir(){ if(VC()) VC().open(); }

  function pinta(){ if(VC()) VC().recargar(); }

  window.VelantisFicha = {regalo: regalo, sumar: sumar};

  /* el estado, en la forma que ya leían las pruebas de la ficha */

  var CFGC = window.VELANTIS_CARRITO_CFG || {};

  CFGC.alPintar = function(E){

    pg.__carrito = {

      lineas: E.items.filter(function(it){ return it.name.indexOf('Bolsillo 30 ml \u00b7 ') !== 0 && it.name !== PAQUETE.obsequio; })

        .map(function(it){ return {nombre: it.name, var: it.v || VC().variante(it.name, it.talla), qty: it.qty, tl: it.talla, precio: it.price}; }),

      total: E.total, permalink: E.permalink, regalo: E.cuenta, regalos: E.regalosVar, sinElegir: E.sinElegir, opciones: E.opcionesVar

    };

    if(window.VelantisFicha.refrescarUpsell44)window.VelantisFicha.refrescarUpsell44();

  };



  /* ------------------------------------------------ compra de la ficha */

  var add = $('#ppAdd'), barra = $('.barra');

  function elegida(){ return $('.pp-tl.on') || $('.pp-tl:not([disabled])'); }

  var DIAS = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'], MESES = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];

  function habiles(n){ var x = new Date(); while(n > 0){ x.setDate(x.getDate() + 1); if(x.getDay() % 6) n--; } return x; }

  function rango(a, b){ var x = habiles(a), y = habiles(b), mx = x.getMonth() === y.getMonth() ? '' : ' de ' + MESES[x.getMonth()];

    return 'entre el ' + DIAS[x.getDay()] + ' ' + x.getDate() + mx + ' y el ' + DIAS[y.getDay()] + ' ' + y.getDate() + ' de ' + MESES[y.getMonth()]; }

  var ship = $('.pp-ship'), eta = $('.pp-eta'), wa = $('.pp-wa');

  function pintaEntrega(){

    if(!ship) return;

    var modo = $('.pp-shipbtn.active', ship).dataset.modo, t = elegida();

    wa.hidden = true;

    if(modo === 'normal') eta.innerHTML = 'Si lo pides hoy, te llegaría <b>' + rango(5, 7) + '</b> (estimado en días hábiles).';

    if(modo === 'express') eta.innerHTML = 'Si lo pides hoy, te llegaría <b>' + rango(1, 3) + '</b> (estimado en días hábiles).';

    if(modo === 'tienda') eta.innerHTML = 'Recógelo en nuestra boutique de <b>Hermosillo</b>. Agrégalo al carrito y al pagar elige <b>Recoger en tienda</b>.';

    if(modo === 'hoy'){

      eta.innerHTML = 'Solo en <b>Hermosillo</b>. Escríbenos y coordinamos la entrega <b>el mismo día</b>.';

      wa.href = 'https://wa.me/' + WA + '?text=' + encodeURIComponent('Hola, quiero ' + pg.dataset.insp + (P.sku ? ' (' + P.sku + (t && t.dataset.et ? ', ' + t.dataset.et : '') + ')' : '') + ' con entrega hoy en Hermosillo.');

      wa.hidden = false;

    }

  }

  function refresca(){

    var t = elegida(); if(!t) return;

    var p = pesos(t.dataset.precio);

    var ap = $('.agr-precio', add); if(ap) ap.textContent = p;

    $('.barra-precio', barra).textContent = p;

    $('.barra-t', barra).textContent = pg.dataset.nom + (t.dataset.et ? ' · ' + t.dataset.et : '');

    pintaEntrega();

    if(window.VelantisFicha.refrescarUpsell44)window.VelantisFicha.refrescarUpsell44();

  }

  $$('button.pp-tl').forEach(function(b){

    b.addEventListener('click', function(){ if(b.disabled) return; $$('button.pp-tl').forEach(function(x){ x.classList.toggle('on', x === b); x.setAttribute('aria-pressed', x === b); }); refresca(); });

  });

  var sel = $('.pp-sel');

  if(sel) sel.addEventListener('change', function(){

    var o = sel.options[sel.selectedIndex], t = elegida();

    t.dataset.tl = o.value; t.dataset.var = o.dataset.var; t.dataset.precio = o.dataset.precio; t.dataset.et = o.dataset.et;

    $('.t-precio', t).textContent = pesos(o.dataset.precio); refresca();

  });

  function itemFicha(t){ var o = {}; o[t.dataset.tl] = [+t.dataset.precio, t.dataset.var, t.dataset.et]; return {sku: P.sku, nombre: pg.dataset.nom, tipo: P.tipo, op: o, b: P.bolsillo ? String(P.bolsillo) : null}; }

  function comprar(){ var t = elegida(); if(!t || add.disabled) return; sumar(itemFicha(t), t.dataset.tl); abrir(); }

  add.addEventListener('click', comprar); $('.barra-add', barra).addEventListener('click', comprar);

  if(ship) $$('.pp-shipbtn', ship).forEach(function(b){ b.addEventListener('click', function(){ $$('.pp-shipbtn', ship).forEach(function(x){ x.classList.toggle('active', x === b); x.setAttribute('aria-pressed', x === b); }); pintaEntrega(); }); });

  $$('.acc-item').forEach(function(it){

    var h = $('.acc-head', it), body = $('.acc-body', it);

    h.addEventListener('click', function(){ var ab = !it.classList.contains('open'); it.classList.toggle('open', ab); h.setAttribute('aria-expanded', ab); body.style.maxHeight = ab ? body.scrollHeight + 'px' : '0px'; });

  });

  var volver = $('.pp-back');

  if(volver && document.referrer && document.referrer.indexOf(location.host) > -1) volver.addEventListener('click', function(e){ e.preventDefault(); history.back(); });

  if('IntersectionObserver' in window){

    var visto = true, dentro = false;

    function pb(){ barra.classList.toggle('visible', !visto && dentro); }

    new IntersectionObserver(function(e){ visto = e[0].isIntersecting || e[0].boundingClientRect.top > 0; pb(); }).observe(add);

    new IntersectionObserver(function(e){ dentro = e[0].isIntersecting; pb(); }, {rootMargin: '-45% 0px -45% 0px'}).observe(pg);

  }

  refresca(); pinta();



  /* ------------------------------------------------ lo que va debajo, desde el catalogo compacto */

  var ICON_CHECK = '<svg viewBox="0 0 24 24"><path d="M5 12l4.5 4.5L19 7"></path></svg>';

  function perfItem(D, s){ var x = D.perf[s]; if(!x) return null;

    return {sku: s, nombre: x.n, casa: x.c, familia: x.f, para: x.p, foto: x.img, op: x.o, h: x.h, b: x.b || null, tipo: 'perfume', nt: x.nt || []}; }

  function hogarItem(i){ return {sku: i.s, nombre: i.n, tipo: i.t, foto: i.img, op: i.o, h: i.h, nd: i.nd, i: i.i}; }

  function datos(it){ return esc(JSON.stringify({sku: it.sku, nombre: it.nombre, tipo: it.tipo, op: it.op, b: it.b || null})); }

  var CDN = '';

  function img(u, w){ if(!u) return ''; if(u.charAt(0) === '~') u = CDN + u.slice(1); return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function notas(it){

    if(!it.nt || !it.nt.length) return '';

    return '<span class="notasGal" aria-hidden="true">' + it.nt.map(function(n, k){

      return '<img class="ng" alt="" loading="lazy" src="' + BASE + n[0] + '" style="left:' + n[1] + '%;top:' + n[2] + '%;--g:' + n[3] + 'deg;--d:' + k + '">'; }).join('') + '</span>';

  }

  function medallon(it, clase){ return '<span class="' + (clase || 'mini') + ' conFoto"><img class="foto" alt="" loading="lazy" decoding="async" src="' + esc(img(it.foto, 520)) + '"></span>'; }

  function pastillas(grupo, ops, on){

    return '<span class="opciones" role="group" aria-label="Presentación">' + ops.map(function(o){

      return '<button type="button" class="opcion' + (o[0] === on ? ' sel' : '') + '" data-grupo="' + grupo + '" data-tl="' + esc(o[0]) + '" aria-pressed="' + (o[0] === on) + '"><b>' + esc(o[1]) + '</b><em>' + pesos(o[2]) + '</em></button>'; }).join('') + '</span>';

  }

  function gal(it, conNotas){

    var ks = Object.keys(it.op), sub = it.tipo === 'perfume' ? 'Inspirado en ' + it.casa : (it.i ? 'Inspirado en ' + it.i[0] : (ks.length > 1 ? (it.tipo === 'aceite' ? 'Aroma para difusor' : '') : pesos(it.op[ks[0]][0])));

    return '<button type="button" class="gal" data-item="' + datos(it) + '" aria-pressed="false"><span class="aro">' + medallon(it) + '<span class="sel-ok" aria-hidden="true">' + ICON_CHECK + '</span></span>' +

      (conNotas ? notas(it) : '') + '<span class="galN"><b>' + esc(it.nombre) + '</b><em>' + esc(sub) + '</em><span class="sku">' + esc(it.sku) + '</span></span></button>';

  }

  function banda(id, eyebrow, titulo, texto, items, base, pills, on, conNotas){

    return '<div class="paq sel-bloque" data-modo="paquete" data-grupo="' + id + '"' + (base ? ' data-base="' + datos(base) + '"' : '') + '>' +

      '<div class="paq-cab"><span class="eb">' + esc(eyebrow) + '</span><h2 class="titulo">' + titulo + '</h2><p class="lay-p">' + texto + '</p></div>' +

      '<div class="tira">' + items.map(function(it){ return gal(it, conNotas); }).join('') + '</div>' +

      '<div class="paq-pie">' + (pills ? '<div class="tallas"><span class="rot">Presentación</span>' + pastillas(id, pills, on) + '</div>' : '') +

      '<div class="ofertas"><button type="button" class="btn grande sel-add"><span class="sel-rot">Agregar al carrito</span><b class="sel-total">$0</b></button><p class="envio sel-envio"></p></div></div></div>';

  }

  function layering(base, par){

    return '<div class="lay"><div class="lay-comp"><div class="duo"><span class="mitad base">' + medallon(base, 'duoFoto') + '</span><span class="mas" aria-hidden="true">+</span><span class="mitad capa">' + medallon(par, 'duoFoto') + '</span></div>' +

      '<div class="duoNombres"><p class="dn"><span class="rot">Primero</span><b>' + esc(base.nombre) + '</b><em>Inspirado en ' + esc(base.casa) + '</em></p><p class="dn"><span class="rot">Encima</span><b>' + esc(par.nombre) + '</b><em>Inspirado en ' + esc(par.casa) + '</em></p></div></div>' +

      '<div class="colB sel-bloque" data-modo="layering" data-base="' + datos(base) + '" data-par="' + datos(par) + '"><span class="eb">Tu firma, tu secreto · el layering</span><h2 class="titulo">El <span class="masTxt">layering</span></h2>' +

      '<p class="lay-p">Combinar dos fragancias para tener un aroma único: una va primero y la otra encima.</p>' +

      '<p class="pruebalo"><b>Pruébalo en tu piel y crea un aroma único.</b> <span>Primero ' + esc(base.nombre) + ' en muñecas y cuello; encima ' + esc(par.nombre) + '. Así, en ese orden.</span></p>' +

      '<div class="tallas"><span class="rot">Presentación</span>' + pastillas('lay', [['50', '50 ml', 390], ['100', '100 ml', 590]].filter(function(o){ return base.op[o[0]] && par.op[o[0]]; }).map(function(o){ return [o[0], o[1], base.op[o[0]][0]]; }), base.op['100'] && par.op['100'] ? '100' : '50') + '</div>' +

      '<div class="ofertas"><button type="button" class="btn grande sel-add"><span class="sel-rot">Agregar los dos al carrito</span><b class="sel-total">$0</b></button><p class="envio sel-envio"></p></div></div></div>';

  }

  function grid(eyebrow, titulo, items, on){

    if(!items.length) return '';

    var cols = (items.length === 4 || items.length >= 7) ? ' c4' : '';

    return '<div class="pp-wrap"><div class="pp-section"><div class="sec-head"><span class="eyebrow">' + esc(eyebrow) + '</span><h2>' + esc(titulo) + '</h2></div><div class="pp-simgrid' + cols + '">' + items.map(function(it){

      var perf = it.tipo === 'perfume', ks = Object.keys(it.op).sort(function(a,b){return (a==='50'?0:a==='100'?1:2)-(b==='50'?0:b==='100'?1:2);}), href = it.h ? '/products/' + it.h + VISTA : '#';

      var tipoTxt = ({ambiental: 'Ambiental', aceite: 'Aroma para difusor', difusor: 'Difusor'})[it.tipo];

      var h4 = perf ? it.nombre : (it.i ? 'Inspirado en ' + it.i[0] : it.nombre);

      var sub = perf ? it.casa : (it.i && it.i[1] ? it.i[1].replace(/^de /, '') : tipoTxt);

      var fam = perf ? it.familia : tipoTxt, chips, boton = '<button class="add" type="button">Agregar al carrito</button>';

      if(ks.length > 4){

        chips = '<span class="pz on solo"><i>Desde</i><b>' + pesos(Math.min.apply(null, ks.map(function(k){ return it.op[k][0]; }))) + '</b></span>';

        boton = '<a class="add" href="' + href + '">Elegir aroma</a>';

      } else {

        chips = ks.map(function(k, i){ var sel = on ? k === on : i === 0; if(on && !it.op[on] && i === 0) sel = true;

          return '<button type="button" class="pz' + (sel ? ' on' : '') + '" data-tl="' + esc(k) + '" aria-pressed="' + sel + '"><i>' + esc(it.op[k][2] || 'Precio') + '</i><b>' + pesos(it.op[k][0]) + '</b></button>'; }).join('');

      }

      var gender = perf ? ({Caballero:'Para él',Dama:'Para ella',Unisex:'Unisex'}[it.para] || it.para || '') : tipoTxt;

      return '<article class="pp-simcard" data-item="' + datos(it) + '"><div class="pp-simimg"><span class="pp-card-code">'+esc(it.sku)+'</span>'+(gender?'<span class="pp-card-gender" data-para="'+esc(it.para||'')+'">'+esc(gender)+'</span>':'')+'<a href="' + href + '"><img src="' + esc(img(it.foto, 480)) + '" alt="Velantis '+esc(h4)+'" loading="lazy" decoding="async"></a></div>' +

        '<div class="pp-simbody">'+(perf?'<span class="pp-card-kicker">Inspirado en</span>':'')+'<h4><a href="' + href + '">' + esc(h4) + '</a></h4><span class="insp">' + esc(sub) + '</span><span class="pr">' + chips + '</span>' + boton + '</div></article>';

    }).join('') + '</div></div></div>';

  }

  function sugerencia(D){

    var g = D.gem[P.sku]; if(!g) return;

    var it = null, tl = null, pie = '';

    if(g[0] === 'perfume'){ it = perfItem(D, g[1]); tl = it && (it.op['100'] ? '100' : '50'); pie = 'El mismo aroma en perfume'; if(it) it.nombre = it.nombre + ' en perfume'; }

    else { var i = D.amb.filter(function(x){ return x.s === g[1]; })[0]; if(i){ it = hogarItem(i); tl = Object.keys(it.op)[0]; pie = P.tipo === 'perfume' ? 'El mismo aroma para tu casa' : 'El mismo aroma en ambiental'; if(it.nombre.indexOf('Ambiental') !== 0) it.nombre = 'Ambiental ' + it.nombre; } }

    if(!it || !it.op[tl]) return;

    var o = it.op[tl], uno = {}; uno[tl] = o;

    $('#ficha-sug').innerHTML = '<div class="pp-sug"><span class="pp-sug-foto"><img src="' + esc(img(it.foto, 200)) + '" alt="" loading="lazy"></span><span class="pp-sug-txt"><span class="pp-sug-ante">' + esc(pie) + '</span><b>' + esc(it.nombre) + '</b><small>' + esc(it.sku) + (o[2] ? ' · ' + esc(o[2]) : '') + ' · ' + pesos(o[0]) + '</small></span>' +

      '<button type="button" class="pp-sug-add" data-item="' + esc(JSON.stringify({sku: it.sku, nombre: it.nombre, tipo: it.tipo, op: uno, b: it.b || null})) + '" data-tl="' + esc(tl) + '" aria-pressed="false"><span class="mas" aria-hidden="true">+</span><span class="rot">Agregar al carrito</span></button></div>';

    var b = $('.pp-sug-add');

    b.addEventListener('click', function(){

      var caja = b.closest('.pp-sug'), puesta = caja.classList.toggle('puesta'), x = JSON.parse(b.dataset.item);

      b.setAttribute('aria-pressed', puesta); $('.mas', b).textContent = puesta ? '✓' : '+'; $('.rot', b).textContent = puesta ? 'En tu carrito' : 'Agregar al carrito';

      if(puesta) sumar(x, b.dataset.tl, 1); else restarVar(x.op[b.dataset.tl][1]);

    });

  }

  function piramideRespaldo(D){

    var caja = $('.pp-pir[data-fallback]'); if(!caja) return;

    var filas = [], nc = D.nc[P.sku];

    if(nc){ filas = [['Salida', nc[0]], ['Corazón', nc[1]], ['Fondo', nc[2]]]; }

    else {

      var m = /Salida:?\s*(.+?)\.?\s+Coraz[oó]n:?\s*(.+?)\.?\s+Fondo:?\s*(.+?)(?:\.\s|\s+Disponible|\s+Ideal|$)/.exec(P.desc || '');

      if(m) filas = [['Salida', m[1]], ['Corazón', m[2]], ['Fondo', m[3]]];

    }

    filas = filas.filter(function(f){ return f[1] && String(f[1]).trim(); });

    if(!filas.length) return;

    caja.innerHTML = '<span class="pp-pir-t">Pirámide olfativa</span><div class="pp-pyr">' + filas.map(function(f){ var s = String(f[1]).trim().replace(/\s+,/g, ','); return '<div class="pp-row"><span>' + f[0] + '</span><p>' + esc(s.charAt(0).toUpperCase() + s.slice(1)) + '</p></div>'; }).join('') + '</div>';

    caja.hidden = false;

  }

  /* Revision 40: copia editorial a partir de familia/notas existentes. No estima rendimiento. */

  var descripcionesEstrenos = {"V618": "Proyecta una frescura relajada: cítricos y notas marinas sobre madera seca. Una opción para días cálidos, planes al aire libre y un estilo casual bien cuidado.", "V616": "Una presencia limpia y serena, con manzana verde, bergamota y un fondo de maderas. Para la oficina, reuniones de día o una salida que pide frescura con carácter.", "V200": "Fresco y desenfadado al inicio, suave y ligeramente dulce al final. Acompaña reuniones informales, tardes de paseo y planes en los que quieres sentirte cómodo sin pasar desapercibido.", "V492": "La naranja sanguina y el azahar dan una impresión luminosa, con musgo que aporta profundidad. Para escapadas, comidas al aire libre y días cálidos con un toque elegante.", "V612": "Deportivo y pulido: pistache verde, ante suave y un fondo amaderado. Encaja en un plan de día, una comida informal o una salida con ropa casual bien elegida.", "V499": "Ciprés, vid y maderas secas para una presencia sobria y discreta. Una propuesta para el trabajo, una cena tranquila o momentos en los que buscas elegancia sin llamar demasiado la atención.", "V497": "Manzana verde y cítricos transmiten energía limpia; el cedro y el ámbar le dan estructura. Para una jornada activa, la oficina o una salida de día en clima templado a cálido.", "V609": "Azafrán, higo y cuero construyen una presencia cálida y con carácter. Para una cena, una cita o una salida nocturna, especialmente cuando el clima se siente fresco.", "V611": "Cuero, humo y cedro, suavizados por vainilla y haba tonka: una impresión firme y envolvente. Para eventos de noche, cenas y planes en clima fresco.", "V489": "Sándalo cremoso, chai y leche para una sensación suave y acogedora. Para una tarde de café, una reunión cercana o un plan tranquilo con un detalle distinto."};

  function plano40(s){return String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();}

  function descripcion40(D,sku){

    if(descripcionesEstrenos[sku])return descripcionesEstrenos[sku];

    var x=D.perf[sku]||{},nc=D.nc[sku]||[],family=x.f||'',f=plano40(family),all=plano40(nc.join(' '));

    // Algunas altas carecen de familia en el índice; el tono editorial se deriva de sus notas registradas.

    var tonosSinFamilia={V126:'floral frutal',V148:'floral almizcle',V193:'floral frutal',V281:'gourmand',V285:'aromatica amaderada',V287:'ambar',V288:'ambar',V292:'gourmand',V296:'gourmand',V298:'ambar',V299:'gourmand',V436:'oriental',V437:'aromatica',V438:'frutal',V443:'gourmand',V509:'floral frutal',V510:'vainilla',V511:'floral',V289:'aromatica amaderada',V414:'floral',V486:'citrica',V516:'floral gourmand'};

    if(!f)f=tonosSinFamilia[sku]||'';

    var signature='Una firma personal con matices que se descubren al llevarla en la piel.';

    if(/cuero/.test(f+' '+all))signature='Un perfil de carácter, con una impresión sobria y envolvente para acompañar una cena o una salida especial.';

    else if(/gourmand|vainilla/.test(f))signature='Una impresión dulce y acogedora, pensada para quien disfruta un aroma envolvente en una cita o un plan cercano.';

    else if(/ambar|oriental/.test(f))signature='Una presencia cálida y envolvente, con un aire elegante para una cena, una reunión especial o un plan al caer la tarde.';

    else if(/citr|acuatic|marin/.test(f))signature='Una impresión fresca y luminosa, de estilo relajado y cuidado para el día a día o un plan al aire libre.';

    else if(/floral/.test(f))signature='Una impresión delicada y expresiva, con un aire cuidado que acompaña tanto una reunión de día como una ocasión especial.';

    else if(/amader/.test(f))signature='Una impresión serena y con carácter, de estilo sobrio para el trabajo, una reunión o una salida tranquila.';

    else if(/aromatic|fougere|verde/.test(f))signature='Una impresión limpia y natural, con un estilo fresco y cuidado para una jornada activa o un encuentro de día.';

    else if(/frutal/.test(f))signature='Una impresión alegre y expresiva, para acompañar planes informales y dar un detalle distinto al día a día.';

    else if(/chipre/.test(f))signature='Una impresión elegante y con contraste, para quien busca una firma con personalidad en una reunión o una salida especial.';

    else if(/almiz/.test(f))signature='Una impresión suave y cercana, con un aire limpio para llevar un aroma personal en los momentos cotidianos.';

    function pick(s){return String(s||'').split(/[.¿?!]/)[0].replace(/\s+,/g,',').replace(/[.;]+$/,'').split(/,|\s+y\s+/).map(function(n){return n.trim();}).filter(Boolean).slice(0,2).join(' y ');}

    var first=pick(nc[0]),last=pick(nc[2]),notes='';

    if(first&&last)notes=' Abre con '+first+' y se apoya en un fondo de '+last+'.';

    else if(first||last)notes=' Sus matices de '+(first||last)+' dan forma a ese carácter.';

    else if(family)notes=' Su perfil '+family.toLowerCase().replace(/\|/g,' y ')+' define su identidad olfativa.';

    return signature+notes;

  }

  window.VelantisFicha.descripcion=descripcion40;

  function proyeccion40(D){

    if(P.tipo!=='perfume')return;

    var target=$('#ppProyeccion');if(!target)return;

    var copy=target.dataset.editorial||descripcion40(D,P.sku);target.textContent=copy;target.hidden=false;

    var about=$('.ficha-desc');if(about)about.textContent=copy;

    target.dataset.fuente=target.dataset.editorial?'metafield':'familia-notas-catalogo';

  }

  function promoFicha40(D){
    var box=$('#ppPromo40');if(!box)return;if(!(window.VELANTIS_OFFERS && window.VELANTIS_OFFERS.gift30Enabled === true)){box.hidden=true;return;}
    var q=$('#ppPromoQ'),results=$('#ppPromoResults'),meta=$('#ppPromoMeta'),clock=$('#ppPromoClock'),more=$('#ppPromoMore'),title=$('#ppPromoTitle'),copy=$('#ppUpsellCopy'),shipping=$('#ppUpsellShipping'),primary=$('#ppUpsellPrimary'),context=$('#ppUpsellContext'),form=q.closest('form');
    var limit=4,found=[],casaFiltro='',orden='fragancia',current=null,scheduled=false,lastSignature='';
    var index=Object.keys(D.perf).map(function(s){var x=D.perf[s];return {sku:s,text:plano40(s+' '+x.n+' '+x.cn+' '+x.c+' '+x.f+' '+(D.nc[s]||[]).join(' '))};});
    var compare=new Intl.Collator('es',{sensitivity:'base',numeric:true}),byVariant={};
    Object.keys(D.perf).forEach(function(s){Object.keys(D.perf[s].o||{}).forEach(function(t){byVariant[String(D.perf[s].o[t][1])]={sku:s,size:t,item:perfItem(D,s)};});});
    var tools=document.createElement('div');tools.className='pp-promo-controls';
    tools.innerHTML='<div class="pp-promo-order" role="group" aria-label="Ordenar de A a Z"><span>Orden A–Z</span><button type="button" data-pp-order="disenador" aria-pressed="false">Por diseñador</button><button type="button" data-pp-order="fragancia" aria-pressed="true">Por fragancia</button></div><div id="ppPromoCasas" class="pp-promo-casas" role="group" aria-label="Diseñadores disponibles" hidden></div>';
    box.insertBefore(tools,meta);var casasBox=$('#ppPromoCasas');
    function cart(){return VC()&&VC().estado?VC().estado():{items:[],total:0,cuenta:{n50:0,n100:0,ganados:0},puestos:[]};}
    function selected(){var t=elegida();return t?{variant:String(t.dataset.var),size:String(t.dataset.et||t.dataset.tl).replace(/[^0-9]/g,''),price:+t.dataset.precio,item:itemFicha(t),node:t}:null;}
    function snapshot(){
      var E=cart(),sel=selected(),n50=E.cuenta.n50,n100=E.cuenta.n100,pending=n50+n100===0,upgrade=null;
      var total=E.total||0;
      if(pending&&sel){if(sel.size==='50')n50=1;else if(sel.size==='100')n100=1;total+=sel.price;}
      if(n50===1&&n100===0){
        if(pending&&sel){var b=$$('button.pp-tl').find(function(x){return !x.disabled&&/100\s*ml/i.test(x.dataset.et||'');});if(b)upgrade={pending:true,node:b,name:pg.dataset.nom,price:+b.dataset.precio,delta:+b.dataset.precio-sel.price};}
        else{var line=(E.items||[]).find(function(x){return x.talla==='50'&&VC().esPerfume(x.name)&&x.price>0;});if(line){var id=String(line.v||VC().variante(line.name,line.talla)),match=byVariant[id];if(match&&match.item.op['100'])upgrade={pending:false,item:match.item,name:match.item.nombre,from:id,price:match.item.op['100'][0],delta:match.item.op['100'][0]-line.price};}}
      }
      var sizes=[];if(n100%2===1)sizes.push('100');if(n50%3===2)sizes.push('50');
      var mode=E.cuenta.ganados>0?'earned':upgrade?'upgrade':pending&&!sel?'unavailable':pending?'start':sizes.length?'add':'progress';
      if(!sizes.length&&!upgrade)sizes=[n100>0?'100':'50'];
      return {E:E,sel:sel,n50:n50,n100:n100,pending:pending,total:total,upgrade:upgrade,sizes:sizes,mode:mode};
    }
    function shippingCopy(s){
      var rates=(VC()||{}).envios||{},tier=+rates.umbralDescuento||500,free=+rates.umbralGratis||s.E.piso||999,cost=+rates.tarifaReducida||50,prefix=s.pending?'Con esta selección, ':'';
      if(s.E.paquetes>0)return 'Tu paquete ya incluye el envío.';
      if(s.total>=free)return prefix+'<b>ya tienes envío gratis.</b>';
      if(s.total<tier)return prefix+'te faltan <b>'+pesos(tier-s.total)+'</b> para que tu envío baje de <del>$180</del> a <strong>'+pesos(cost)+'</strong>.';
      return prefix+'tu envío baja de <del>$180</del> a <strong>'+pesos(cost)+'</strong>. Te faltan <b>'+pesos(free-s.total)+'</b> para envío gratis.';
    }
    function casasDisponibles(base){
      var casas=[];base.forEach(function(o){var c=D.perf[o.sku].c||'Velantis';if(casas.indexOf(c)<0)casas.push(c);});casas.sort(compare.compare);if(casaFiltro&&casas.indexOf(casaFiltro)<0)casaFiltro='';
      var focus=casasBox.contains(document.activeElement)?document.activeElement.dataset.ppCasa:null,scroll=casasBox.scrollLeft;
      casasBox.innerHTML=[''].concat(casas).map(function(c){return '<button type="button" data-pp-casa="'+esc(c)+'" aria-pressed="'+String(c===casaFiltro)+'">'+esc(c||'Todos los diseñadores')+'</button>';}).join('');casasBox.hidden=!casas.length||(!q.value.trim()&&orden!=='disenador');casasBox.scrollLeft=scroll;
      if(focus!==null){var b=Array.from(casasBox.children).find(function(x){return x.dataset.ppCasa===focus;})||casasBox.firstElementChild;if(b)b.focus({preventScroll:true});}
    }
    function paint(){
      if(!current||current.mode==='upgrade'||current.mode==='start'||current.mode==='earned'){results.innerHTML='';more.hidden=true;return;}
      var term=plano40(q.value.trim()),sizes=current.sizes;
      var base=index.filter(function(x){var p=D.perf[x.sku];return x.sku!==P.sku&&sizes.some(function(t){return !!p.o[t];})&&(!term||VelantisBusqueda.coincidencia(q.value,{sku:x.sku,nombre:p.n,casa:p.c,texto:x.text})>0);});
      casasDisponibles(base);found=casaFiltro?base.filter(function(o){return (D.perf[o.sku].c||'Velantis')===casaFiltro;}):base;
      var sims=D.sim[P.sku]||[];
      found.sort(function(a,b){var x=D.perf[a.sku],y=D.perf[b.sku],name=compare.compare(x.n,y.n),house=compare.compare(x.c||'Velantis',y.c||'Velantis');if(!term&&orden==='fragancia'&&!casaFiltro){var ai=sims.indexOf(a.sku),bi=sims.indexOf(b.sku);if(ai!==bi&&(ai>=0||bi>=0))return (ai<0?999:ai)-(bi<0?999:bi);}return (orden==='disenador'?house||name:name||house)||compare.compare(a.sku,b.sku);});
      meta.textContent=found.length?(term?found.length+(found.length===1?' fragancia encontrada.':' fragancias encontradas.'):'Opciones para completar tu selección.'):'No encontramos esa fragancia en la presentación que activa tu promoción. Prueba otro nombre, diseñador o código.';
      var chosen=current.sel&&sizes.indexOf(current.sel.size)>=0?current.sel.size:sizes[0];
      var items=found.slice(0,limit).map(function(x){var it=perfItem(D,x.sku),ops={};sizes.forEach(function(t){if(it.op[t])ops[t]=it.op[t];});it.op=ops;return it;});
      results.innerHTML=items.length?grid('','',items,chosen):'';more.hidden=found.length<=limit;atarTarjetas40(results);
    }
    function sync(){
      scheduled=false;var s=snapshot(),signature=JSON.stringify([s.mode,s.n50,s.n100,s.total,s.sel&&s.sel.variant,s.E.puestos,s.E.items.map(function(i){return [i.name,i.talla,i.qty];})]);if(signature===lastSignature)return;lastSignature=signature;current=s;
      box.dataset.upsell=s.mode;box.dataset.n50=String(s.n50);box.dataset.n100=String(s.n100);box.dataset.subtotal=String(s.total);
      context.textContent=s.pending?'Tu selección: '+(s.sel?s.sel.size+' ml · '+pesos(s.sel.price):'elige una presentación'):'En tu carrito: '+[s.n100?s.n100+' de 100 ml':'',s.n50?s.n50+' de 50 ml':''].filter(Boolean).join(' · ');
      shipping.innerHTML=shippingCopy(s);primary.hidden=false;
      if(s.mode==='upgrade'){
        title.innerHTML='Lleva el doble.<br> <em>Por '+pesos(s.upgrade.delta)+' más.</em>';
        copy.textContent='Cambia '+s.upgrade.name+' de 50 ml a 100 ml por '+pesos(s.upgrade.price)+'.';primary.textContent='Cambiar a 100 ml · +'+pesos(s.upgrade.delta);
      }else if(s.mode==='start'){
        title.innerHTML='Completa tu selección.<br> <em>Recibe 30 ml de regalo.</em>';
        copy.textContent='Primero agrega esta fragancia de '+s.sel.size+' ml. Después '+(s.sel.size==='100'?'añade otra de 100 ml':'completa tres de 50 ml')+' y elige tu regalo en el carrito.';primary.textContent='Agregar esta de '+s.sel.size+' ml · '+pesos(s.sel.price);
      }else if(s.mode==='earned'){
        title.innerHTML='Tu regalo de 30 ml<br> <em>ya está incluido.</em>';copy.textContent='Completaste la promoción. Elige la fragancia de tu frasco de 30 ml desde el carrito.';primary.textContent=s.E.puestos.length?'Ver mi regalo en el carrito':'Elegir mi fragancia de regalo';
      }else if(s.mode==='unavailable'){
        title.innerHTML='Encuentra tu próxima fragancia.';copy.textContent='Esta presentación no está disponible. Explora otras fragancias del catálogo.';primary.hidden=true;
      }else{
        var label=s.sizes.length>1?'una fragancia':'una de '+s.sizes[0]+' ml';
        title.innerHTML=s.mode==='add'?'Añade '+label+'.<br> <em>Y recibe 30 ml de regalo.</em>':'Completa tu selección.<br> <em>Recibe 30 ml de regalo.</em>';
        copy.textContent=s.mode==='add'?'Las opciones de abajo completan la promoción con una sola adición. Elige la fragancia de regalo en el carrito.':'Te faltan '+(s.n100?2-s.n100%2:3-s.n50%3)+' fragancias de '+s.sizes[0]+' ml para recibir tu frasco de 30 ml de regalo.';primary.hidden=true;
      }
      var browse=s.mode==='add'||s.mode==='progress'||s.mode==='unavailable';form.hidden=!browse;tools.hidden=!browse;meta.hidden=!browse;results.hidden=!browse;limit=4;paint();
    }
    function queue(){if(!scheduled){scheduled=true;requestAnimationFrame(sync);}}
    window.VelantisFicha.refrescarUpsell44=queue;
    primary.addEventListener('click',function(){
      var s=snapshot();
      if(s.mode==='upgrade'){
        if(s.upgrade.pending)s.upgrade.node.click();
        else if(sumar(s.upgrade.item,'100',1))restarVar(s.upgrade.from);
      }else if(s.mode==='start'){var t=elegida();if(t)sumar(itemFicha(t),t.dataset.tl,1);}
      else if(s.mode==='earned')abrir();
      queue();
    });
    tools.addEventListener('click',function(e){var order=e.target.closest('[data-pp-order]'),house=e.target.closest('[data-pp-casa]');if(order){orden=order.dataset.ppOrder;tools.querySelectorAll('[data-pp-order]').forEach(function(b){b.setAttribute('aria-pressed',String(b===order));});}else if(house)casaFiltro=house.dataset.ppCasa||'';else return;limit=4;paint();});
    q.addEventListener('input',function(){limit=4;paint();});form.addEventListener('submit',function(e){e.preventDefault();limit=4;paint();});more.addEventListener('click',function(){limit+=4;paint();});q.addEventListener('focus',function(){box.classList.add('interactuada');});
    function tick(){var left=Math.max(0,Math.floor((Date.parse(box.dataset.end)-Date.now())/1000));if(!left){box.hidden=true;return;}var values=[Math.floor(left/86400),Math.floor(left/3600)%24,Math.floor(left/60)%60,left%60];$$('.pp-promo-digit',clock).forEach(function(n,i){n.textContent=String(values[i]).padStart(2,'0');});}
    tick();setInterval(tick,1000);sync();
    if('IntersectionObserver' in window){var io=new IntersectionObserver(function(es){if(es.some(function(e){return e.isIntersecting;})){box.classList.add('invitar');setTimeout(function(){box.classList.remove('invitar');},5000);io.disconnect();}},{threshold:.3});io.observe(box);}
  }

  function atarTarjetas40(root){

    $$('.pp-simcard',root).forEach(function(c){

      if(c.dataset.bound40)return;c.dataset.bound40='1';

      $$('.pz:not(.solo)',c).forEach(function(z){z.addEventListener('click',function(){$$('.pz',c).forEach(function(x){x.classList.toggle('on',x===z);x.setAttribute('aria-pressed',String(x===z));});});});

      var b=$('.add',c);if(b&&b.tagName==='BUTTON')b.addEventListener('click',function(){var it=JSON.parse(c.dataset.item),z=$('.pz.on',c);if(z&&sumar(it,z.dataset.tl))abrir();});

    });

  }



var IDENTIDADES45={"abercrombiefitch": {"classes": "claro a-marea t-cordon", "t": "#EEF1F0", "c": "#4A6A72", "l": "#1A1E1F", "url": "/collections/abercrombie-fitch"}, "amouage": {"classes": "oscuro a-heraldo t-arabesco", "t": "#0B1418", "c": "#C9A227", "l": "#EFE8D8", "url": "/collections/amouage"}, "arianagrande": {"classes": "oscuro a-perla t-lunares", "t": "#160D1C", "c": "#C79BD8", "l": "#F3EAF3", "url": "/collections/ariana-grande"}, "armaf": {"classes": "oscuro a-bruma t-vetas", "t": "#14100B", "c": "#A67C4A", "l": "#EDE4D4", "url": "/collections/armaf"}, "azzaro": {"classes": "oscuro a-marea t-reglas", "t": "#0A0E14", "c": "#4A8CC2", "l": "#E8EFF4", "url": "/collections/azzaro"}, "bdkparfums": {"classes": "oscuro a-bruma t-vetas", "t": "#14100B", "c": "#A67C4A", "l": "#EDE4D4", "url": "/collections/bdk-parfums"}, "bharara": {"classes": "oscuro a-metal t-facetas", "t": "#0C0C10", "c": "#B08C4A", "l": "#EDE7D8", "url": "/collections/bharara"}, "bondno9": {"classes": "oscuro a-corte t-reglas", "t": "#101018", "c": "#D14B6A", "l": "#EFEAE2", "url": "/collections/bond-no-9"}, "burberry": {"classes": "claro a-niebla t-cuadros", "t": "#E5DAC4", "c": "#7A5C2E", "l": "#2A2620", "url": "/collections/burberry"}, "bvlgari": {"classes": "oscuro a-perla t-facetas", "t": "#0F1418", "c": "#C9A227", "l": "#EFE9DC", "url": "/collections/bvlgari"}, "byredo": {"classes": "claro a-papel t-lino", "t": "#EFEDE7", "c": "#5A5A55", "l": "#1D1E1B", "url": "/collections/byredo"}, "cacharel": {"classes": "claro a-seda t-rosa", "t": "#F2EDE9", "c": "#B0416E", "l": "#1F1B1D", "url": "/collections/cacharel"}, "carolinaherrera": {"classes": "claro a-seda t-lunares", "t": "#F4F1EC", "c": "#C41230", "l": "#1A1418", "url": "/collections/carolina-herrera"}, "chanel": {"classes": "oscuro a-laca t-acolchado", "t": "#0B0B0B", "c": "#E8E4DC", "l": "#F5F2EA", "url": "/collections/chanel"}, "creed": {"classes": "oscuro a-heraldo t-heraldica", "t": "#101C18", "c": "#9BB6A0", "l": "#EDE8DA", "url": "/collections/creed"}, "dior": {"classes": "claro a-perla t-cannage", "t": "#E8E4DB", "c": "#7E6317", "l": "#232529", "url": "/collections/dior"}, "dolcegabbana": {"classes": "oscuro a-bruma t-vetas", "t": "#14100B", "c": "#A67C4A", "l": "#EDE4D4", "url": "/collections/dolce-gabbana"}, "escentricmolecules": {"classes": "claro a-papel t-cordon", "t": "#EDEDEA", "c": "#4A4A4A", "l": "#1A1A1A", "url": "/collections/escentric-molecules"}, "ferragamo": {"classes": "claro a-seda t-rosa", "t": "#F2EDE9", "c": "#9C4A66", "l": "#1F1B1D", "url": "/collections/ferragamo"}, "giardiniditoscana": {"classes": "claro a-bruma t-yeso", "t": "#EDE1CD", "c": "#A05423", "l": "#2B2519", "url": "/collections/giardini-di-toscana"}, "giorgioarmani": {"classes": "claro a-barrido t-lino", "t": "#DBD7CE", "c": "#5C6875", "l": "#1B1D20", "url": "/collections/giorgio-armani"}, "givenchy": {"classes": "oscuro a-laca t-reglas", "t": "#0B0B0C", "c": "#C08496", "l": "#F0EDE6", "url": "/collections/givenchy"}, "gucci": {"classes": "oscuro a-seda t-rayas", "t": "#12241B", "c": "#B5121B", "l": "#F0E9D8", "url": "/collections/gucci"}, "hermes": {"classes": "claro a-bruma t-cuero", "t": "#F2E4D0", "c": "#B5551E", "l": "#221E18", "url": "/collections/hermes"}, "isseymiyake": {"classes": "claro a-marea t-cordon", "t": "#E6EDF0", "c": "#3E6A82", "l": "#181E22", "url": "/collections/issey-miyake"}, "jeanpaulgaultier": {"classes": "claro a-marea t-marinera", "t": "#EFEDE7", "c": "#1B3A6B", "l": "#171C24", "url": "/collections/jean-paul-gaultier"}, "jomalonelondon": {"classes": "claro a-papel t-lino", "t": "#F0EDE4", "c": "#6E6A2E", "l": "#20211C", "url": "/collections/jo-malone"}, "juicycouture": {"classes": "claro a-seda t-rosa", "t": "#F2EDE9", "c": "#B0416E", "l": "#1F1B1D", "url": "/collections/juicy-couture"}, "kayali": {"classes": "oscuro a-perla t-facetas", "t": "#1A0F1E", "c": "#C9A227", "l": "#F3E9E4", "url": "/collections/kayali"}, "lancome": {"classes": "claro a-seda t-rosa", "t": "#F2EDEA", "c": "#A83C68", "l": "#1E1A1C", "url": "/collections/lancome"}, "lattafaperfumes": {"classes": "oscuro a-perla t-facetas", "t": "#160F0A", "c": "#CE8A9C", "l": "#F0E6D6", "url": "/collections/lattafa"}, "lelabo": {"classes": "claro a-papel t-hilvan", "t": "#EDEAE2", "c": "#4A4A46", "l": "#1C1C1A", "url": "/collections/le-labo"}, "loewe": {"classes": "claro a-bruma t-cuero", "t": "#EFEAE0", "c": "#8A6A3C", "l": "#20211D", "url": "/collections/loewe"}, "louisvuitton": {"classes": "oscuro a-barrido t-damero", "t": "#1B1208", "c": "#C8A24A", "l": "#F0E7D6", "url": "/collections/louis-vuitton"}, "maisoncrivelli": {"classes": "oscuro a-niebla t-cuero", "t": "#100C0A", "c": "#8C6039", "l": "#EAE2D6", "url": "/collections/maison-crivelli"}, "maisonfranciskurkdjian": {"classes": "claro a-perla t-cannage", "t": "#EDEAE0", "c": "#7A6A3E", "l": "#1F211C", "url": "/collections/maison-francis-kurkdjian"}, "maisonmargiela": {"classes": "claro a-papel t-hilvan", "t": "#F2F0EB", "c": "#66625A", "l": "#22231F", "url": "/collections/maison-martin-margiela"}, "mancera": {"classes": "oscuro a-metal t-heraldica", "t": "#12100A", "c": "#B98A3B", "l": "#EFE6D2", "url": "/collections/mancera"}, "marcjacobs": {"classes": "claro a-papel t-lunares", "t": "#F2EEE8", "c": "#B0567E", "l": "#1F1B1E", "url": "/collections/marc-jacobs"}, "montale": {"classes": "oscuro a-metal t-cordon", "t": "#0A0F14", "c": "#7FA8C9", "l": "#E6EDF2", "url": "/collections/montale"}, "montblanc": {"classes": "oscuro a-laca t-reglas", "t": "#0C0C0E", "c": "#D8D4CB", "l": "#F1EFE9", "url": "/collections/montblanc"}, "moschino": {"classes": "claro a-seda t-lunares", "t": "#F4EFE6", "c": "#C4342E", "l": "#1E1A18", "url": "/collections/moschino"}, "mugler": {"classes": "oscuro a-metal t-facetas", "t": "#080D14", "c": "#5FA8D3", "l": "#E8F0F6", "url": "/collections/mugler"}, "narcisorodriguez": {"classes": "claro a-papel t-lino", "t": "#F0ECE6", "c": "#A0606E", "l": "#1D1B19", "url": "/collections/narciso-rodriguez"}, "ortoparisi": {"classes": "oscuro a-metal t-cordon", "t": "#0A0A0A", "c": "#8C8C8C", "l": "#E6E6E4", "url": "/collections/orto-parisi"}, "parfumsdemarly": {"classes": "oscuro a-heraldo t-heraldica", "t": "#0D1B33", "c": "#C8A96A", "l": "#F0E9DA", "url": "/collections/parfums-de-marly"}, "prada": {"classes": "oscuro a-nailon t-cordon", "t": "#0C1310", "c": "#5FA383", "l": "#CFC8B8", "url": "/collections/prada"}, "rabanne": {"classes": "oscuro a-metal t-discos", "t": "#0D0F14", "c": "#CBB26A", "l": "#DCE0E6", "url": "/collections/paco-rabanne"}, "ralphlauren": {"classes": "oscuro a-barrido t-rayas", "t": "#0B1220", "c": "#BC8898", "l": "#EFE9DC", "url": "/collections/ralph-lauren"}, "room1015": {"classes": "claro a-sol t-lunares", "t": "#F4EDE6", "c": "#B0562E", "l": "#201B18", "url": "/collections/room-1015"}, "soldejaneiro": {"classes": "claro a-sol t-yeso", "t": "#F5E6CE", "c": "#D0708A", "l": "#241E16", "url": "/collections/sol-de-janeiro"}, "thomaskosmala": {"classes": "claro a-sol t-lino", "t": "#F0F0E4", "c": "#6E7A2E", "l": "#1C1E18", "url": "/collections/thomas-kosmala"}, "tomford": {"classes": "oscuro a-laca t-vetas", "t": "#0A0A0A", "c": "#C6A664", "l": "#E9E2D3", "url": "/collections/tom-ford"}, "valentino": {"classes": "oscuro a-seda t-tachas", "t": "#14060B", "c": "#C8102E", "l": "#F2E7E4", "url": "/collections/valentino"}, "versace": {"classes": "oscuro a-laca t-greca", "t": "#0B0B0B", "c": "#D4AF37", "l": "#F2EDE0", "url": "/collections/versace"}, "viktorrolf": {"classes": "oscuro a-perla t-facetas", "t": "#0E0A14", "c": "#C9A227", "l": "#F0EAE6", "url": "/collections/viktor-rolf"}, "xerjoff": {"classes": "oscuro a-perla t-facetas", "t": "#0E0B12", "c": "#B08CC9", "l": "#EFE8F0", "url": "/collections/xerjoff"}, "yvessaintlaurent": {"classes": "oscuro a-laca t-reglas", "t": "#0B0B0C", "c": "#D4A017", "l": "#F1EDE4", "url": "/collections/yves-saint-laurent"}};
  /* R45: la casa se resuelve desde el catálogo compartido y las identidades vigentes. */
  function masDeLaCasa45(D,base){
    var norm=window.VelantisBusqueda.normalizar,house=norm(base.casa),items=Object.keys(D.perf).filter(function(s){return s!==P.sku&&norm(D.perf[s].c)===house;}).map(function(s){return perfItem(D,s);}).filter(Boolean);
    if(!items.length)return '';
    items.sort(function(a,b){return a.nombre.localeCompare(b.nombre,'es');});
    var identity=IDENTIDADES45[house]||{classes:'claro',t:'#f5f0e6',c:'#ac8b47',l:'#24364c'},url=identity.url||'';
    return '<section id="ppDesigner45" class="pp-designer" data-house="'+esc(base.casa)+'"><div class="pp-house-art '+identity.classes+'" style="--t:'+identity.t+';--c:'+identity.c+';--l:'+identity.l+'" aria-hidden="true"><span class="pp-house-color"></span><span class="pp-house-pattern"></span></div>'+grid('Explora la misma casa','Más inspiraciones de '+base.casa,items,'50')+'<div class="pp-house-actions">'+(items.length>4?'<button type="button" id="ppHouseMore45" aria-expanded="false">Cargar '+(items.length-4)+' fragancias más</button>':'')+(url?'<a href="'+esc(url)+'">Ver toda la colección de '+esc(base.casa)+' →</a>':'')+'</div></section>';
  }
  function elixir45(){return '<section id="ppElixir45" class="pp-home-story" aria-labelledby="ppElixirTitle" style="--vl50-background:url('+esc(BASE+'velantis-concentracion-fondo.webp')+')"><div class="v27-story-inner"><div class="v27-story-copy"><span class="v27-eyebrow">Perfumería boutique · Hermosillo</span><h2 id="ppElixirTitle">Alta perfumería.<br><strong>A tu alcance.</strong></h2><p>Interpretamos grandes fragancias con materias primas de calidad y concentración tipo Elixir. Encuentra el aroma que va contigo.</p><div class="vl-home-story-seal"><strong>40<span>%</span></strong><span><b>de concentración</b><small>La máxima permitida en México</small></span></div><a class="v27-link" href="/pages/nosotros">Conoce Velantis <span aria-hidden="true">↗</span></a></div></div></section>';}
  function resena45(){
    var trigger=document.getElementById('ppReview45');if(!trigger)return;
    var dialog=document.createElement('dialog');dialog.id='ppReviewDialog45';dialog.className='pp-review-dialog';dialog.setAttribute('aria-labelledby','ppReviewTitle45');dialog.innerHTML='<div class="pp-review-head"><h2 id="ppReviewTitle45">Tu opinión cuenta</h2><button type="button" aria-label="Cerrar reseña">×</button></div><iframe title="Registro Privé y reseña de tu fragancia"></iframe>';document.body.appendChild(dialog);
    var frame=dialog.querySelector('iframe'),last=null;
    function close(){dialog.close();if(last)last.focus({preventScroll:true});}
    var loading=false;
    trigger.addEventListener('click',function(){last=document.activeElement;dialog.showModal();if(frame.dataset.loaded||loading)return;loading=true;var u=new URL('/pages/registro-prive',location.origin),handle=location.pathname.split('/').pop();u.searchParams.set('embed','1');u.searchParams.set('producto',handle);var preview=new URL(location.href).searchParams.get('preview_theme_id');if(!preview&&window.Shopify&&Shopify.theme&&Shopify.theme.role==='unpublished')preview=Shopify.theme.id;if(preview)u.searchParams.set('preview_theme_id',preview);
      frame.srcdoc='<p style="font:14px Arial;padding:25px;color:#24364c" role="status">Cargando tu formulario…</p>';
      fetch(u.href).then(function(r){if(!r.ok)throw Error();return r.text();}).then(function(html){var doc=new DOMParser().parseFromString(html,'text/html'),main=doc.querySelector('main.prive'),js=Array.from(doc.scripts).find(function(s){return s.src&&s.src.indexOf('/registro-prive.js')>=0;}),config=Array.from(doc.scripts).find(function(s){return !s.src&&s.textContent.trim().indexOf('window.VelantisPriveConfig=')===0;});if(!main||!js||!config)throw Error();var head=Array.from(doc.querySelectorAll('link[rel="stylesheet"]')).map(function(x){return x.outerHTML;}).join('');frame.srcdoc='<!doctype html><html lang="es"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1">'+head+'</head><body>'+main.outerHTML+'<script>window.VelantisPriveEmbed='+JSON.stringify({embedded:true,product:handle}).replace(/</g,'\\u003c')+';'+config.textContent+'<\/script><script src="'+esc(js.src)+'"><\/script></body></html>';frame.dataset.loaded='1';}).catch(function(){frame.srcdoc='<p style="font:14px Arial;padding:25px;color:#24364c">No pudimos cargar el formulario. <a target="_blank" rel="noopener" href="'+esc(u.href)+'">Abrir Registro Privé</a> o cierra y vuelve a intentarlo.</p>';}).finally(function(){loading=false;});
    });
    dialog.querySelector('button').addEventListener('click',close);dialog.addEventListener('click',function(e){var r=dialog.getBoundingClientRect();if(e.target===dialog&&(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom))close();});
    dialog.addEventListener('cancel',function(e){e.preventDefault();close();});
    frame.addEventListener('load',function(){try{frame.contentDocument.addEventListener('keydown',function(e){if(e.key==='Escape'){e.preventDefault();close();}});frame.contentDocument.addEventListener('click',function(e){if(e.target.closest('.prive-done a.submit')){e.preventDefault();frame.srcdoc=frame.srcdoc;}});}catch(e){}});
    var more=document.getElementById('ppHouseMore45');if(more)more.onclick=function(){var section=document.getElementById('ppDesigner45'),open=more.getAttribute('aria-expanded')!=='true';more.setAttribute('aria-expanded',String(open));section.classList.toggle('pp-house-expanded',open);more.textContent=open?'Mostrar las primeras 4':'Cargar '+(section.querySelectorAll('.pp-simcard').length-4)+' fragancias más';};
  }

  function abajo(D){

    var out = '', bandaAbierta = [], yo = P.sku;

    function cierra(){ if(bandaAbierta.length){ out += '<section class="banda"><div class="pp-wrap banda-in">' + bandaAbierta.join('') + '</div></section>'; bandaAbierta = []; } }

    var aceites = D.ace.filter(function(i){ return i.s !== yo; }).map(hogarItem);

    var pillsAce = aceites.length ? Object.keys(aceites[0].op).map(function(k){ return [k, aceites[0].op[k][2], aceites[0].op[k][0]]; }) : null;

    if(P.tipo === 'perfume'){

      var base = perfItem(D, yo);

      if(base){

        var par = D.perf[yo].par ? perfItem(D, D.perf[yo].par) : null;

        /* Layering archivado en revision-40-ficha-comentarios/archivo-layering. */

        var gen = base.para, lz = D.lanz.filter(function(x){ return x[1] === gen && x[0] !== yo; }).map(function(x){ return perfItem(D, x[0]); }).filter(Boolean);

        var PARA = {Caballero: 'para él', Dama: 'para ella', Unisex: 'unisex'};

        if(lz.length) bandaAbierta.push(banda('paq', 'Arma tu paquete', 'Complétalo con <span class="masTxt">lo más nuevo</span>',

          'Lanzamientos recientes ' + (PARA[gen] || '') + '. Toca los que quieras sumar a tu ' + esc(base.nombre) + ' y arma tu selección a tu gusto.',

          lz, base, [['50', '50 ml', 390], ['100', '100 ml', 590]], '100', true));

        cierra();

        out += masDeLaCasa45(D,base) + elixir45();

        out += grid('También te puede gustar', 'Fragancias similares', (D.sim[yo] || []).map(function(s){ return perfItem(D, s); }).filter(Boolean), '50');

      }

    } else if(P.tipo === 'ambiental'){

      out += grid('Para tu casa', 'Más fragancias', D.amb.filter(function(i){ return i.s !== yo; }).slice(0, 6).map(hogarItem), null);

      bandaAbierta.push(banda('ace', 'Para tu difusor', 'Aceites para <span class="masTxt">difusor</span>', 'El aroma de tus espacios, en esencia para difusor.', aceites.slice(0, 8), null, pillsAce, pillsAce && pillsAce[0][0], false));

      cierra();

    } else if(P.tipo === 'difusor'){

      bandaAbierta.push(banda('ace', 'Para tu difusor', 'Aceites para <span class="masTxt">tu difusor</span>', 'Cuando se acabe la esencia incluida, aquí están los aromas para difusor.', aceites.slice(0, 8), null, pillsAce, pillsAce && pillsAce[0][0], false));

      cierra();

    } else if(P.tipo === 'aceite'){

      bandaAbierta.push(banda('ace', 'Para tu difusor', 'Más <span class="masTxt">aceites</span>', 'Otros aromas para difusor.', aceites.slice(0, 8), null, pillsAce, pillsAce && pillsAce[0][0], false));

      cierra();

      out += grid('Para tus espacios', 'Difusores', D.dif.map(hogarItem), null);

      var gemelo = D.gem[yo] ? D.gem[yo][1] : null;

      out += grid('Para tu casa', 'Aromatizantes', D.amb.filter(function(i){ return i.s !== gemelo; }).slice(0, 6).map(hogarItem), null);

    }

    $('#ficha-abajo').innerHTML = out;

    atar();

  }

  function atar(){

    atarTarjetas40(pg);

    $$('.sel-bloque').forEach(function(bl){

      var grupo = bl.dataset.modo === 'layering' ? 'lay' : bl.dataset.grupo;

      var base = bl.dataset.base ? JSON.parse(bl.dataset.base) : null, par = bl.dataset.par ? JSON.parse(bl.dataset.par) : null;

      function talla(it){ var p = $('.opcion.sel[data-grupo="' + grupo + '"]', bl); var tl = p ? p.dataset.tl : Object.keys(it.op)[0]; return it.op[tl] ? tl : Object.keys(it.op)[0]; }

      function piezas(){ var o = []; if(base) o.push(base); if(par) o.push(par); $$('.gal.sel', bl).forEach(function(g){ o.push(JSON.parse(g.dataset.item)); }); return o; }

      function pintaBl(){

        var ps = piezas(), total = 0, sim = [];

        ps.forEach(function(it){ var tl = talla(it); total += it.op[tl][0]; sim.push({tipo: it.tipo, tl: tl, qty: 1}); });

        var n = ps.length, nombres = ['Elige los que quieras', 'Agregar al carrito', 'Agregar los dos al carrito', 'Agregar las tres al carrito'];

        $('.sel-rot', bl).textContent = nombres[n] || ('Añadir las ' + n + ' al carrito');

        $('.sel-total', bl).textContent = pesos(total); $('.sel-add', bl).disabled = n === 0;

        var r = regalo(sim);

        $('.sel-envio', bl).innerHTML = n ? ((base && n === 1 ? 'Tu ' + esc(base.nombre) + ' ya va en el paquete. ' : '') + lineaEnvio(total) + (r.ganados ? ' <b>Incluye tu frasco de bolso de 30 ml, gratis.</b>' : '')) : 'Toca las piezas para armar tu pedido.';

      }

      $$('.opcion', bl).forEach(function(o){ o.addEventListener('click', function(){ $$('.opcion', bl).forEach(function(x){ x.classList.toggle('sel', x === o); x.setAttribute('aria-pressed', x === o); }); pintaBl(); }); });

      $$('.gal', bl).forEach(function(g){ g.addEventListener('click', function(){ var s = g.classList.toggle('sel'); g.setAttribute('aria-pressed', s); pintaBl(); }); });

      $('.sel-add', bl).addEventListener('click', function(){ var ps = piezas(); if(!ps.length) return; ps.forEach(function(it){ sumar(it, talla(it), 1); }); abrir(); });

      pintaBl();

      var tira = $('.tira', bl);

      if(tira && 'IntersectionObserver' in window){ var ojo = new IntersectionObserver(function(v){ v.forEach(function(e){ e.target.classList.toggle('abierta', e.isIntersecting); }); }, {root: tira, threshold: .55}); $$('.gal', tira).forEach(function(g){ ojo.observe(g); }); }

      else if(tira) $$('.gal', tira).forEach(function(g){ g.classList.add('abierta'); });

    });

    pg.dataset.listo = '1';

  }



  /* ---------------------------------------------------- el buscador de la barra

     En la ficha el icono llevaba a /search —la búsqueda de Shopify, que no conoce el

     catálogo del sitio—. Aquí busca en los mismos datos que ya carga la ficha: nombre,

     casa, familia y código, con su foto y su página. */

  function buscadorFicha(D){

    var ov = document.getElementById('fbOv'), q = document.getElementById('fbQ'),

        res = document.getElementById('fbRes'), meta = document.getElementById('fbMeta');

    if(!ov || !q) return;

    var IDX = Object.keys(D.perf || {}).map(function(k){

      var x = D.perf[k];

      return {cod: k, n: x.n || x.cn || k, c: x.c || '', f: x.f || '', h: x.h || '',

              img: x.img || '', b: plano(k + ' ' + (x.n || '') + ' ' + (x.cn || '') + ' ' + (x.c || '') + ' ' + (x.f || '') + ' ' + JSON.stringify(x.nt || x.nd || []) + ' ' + JSON.stringify((D.nc || {})[k] || []))};

    });

    ['amb','ace','dif'].forEach(function(key){(D[key]||[]).forEach(function(x){var tipo=key==='ace'?'Aceite para difusor':key==='dif'?'Difusor':'Aromatizante';IDX.push({cod:x.s||'',n:x.n||'',c:tipo,f:x.i?x.i.join(' '):'',h:x.h||'',img:x.img||'',b:plano((x.s||'')+' '+(x.n||'')+' '+(x.alias||'')+' '+tipo+' '+(key==='dif'?'difusores nebulizador':key==='ace'?'aceites recarga':'ambientales')+' '+JSON.stringify(x.nd||[]))});});});
    function plano(s){ return String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase(); }

    function foto(u){ return u ? (u.charAt(0) === '~' ? CDN + u.slice(1) : u) : ''; }

    function pinta(){

      var t = plano(q.value.trim());

      if(t.length < 2){ meta.textContent = ''; res.innerHTML = '<p class="fb-vacio">Escribe para buscar entre ' + IDX.length + ' fragancias.</p>'; return; }

      var hay = IDX.map(function(x){return {x:x,score:VelantisBusqueda.coincidencia(q.value,{sku:x.cod,nombre:x.n,casa:x.c,texto:x.b})};}).filter(function(o){return o.score>0;}).sort(function(a,b){return b.score-a.score;}).map(function(o){return o.x;});

      meta.textContent = hay.length ? hay.length + (hay.length === 1 ? ' resultado' : ' resultados') : '';

      res.innerHTML = hay.length

        ? hay.slice(0, 24).map(function(x){

            var f = foto(x.img);

            return '<button class="fb-it" type="button" data-h="' + esc(x.h) + '">' +

              '<span class="fb-fo"' + (f ? ' style="background-image:url(\'' + esc(f) + '&width=120\')"' : '') + '></span>' +

              '<span><span class="fb-n">' + esc(x.n) + '</span>' +

              '<span class="fb-s">' + esc(x.cod) + (x.c ? ' · ' + esc(x.c) : '') + (x.f ? ' · ' + esc(x.f) : '') + '</span></span></button>';

          }).join('')

        : '<p class="fb-vacio">Nada con «' + esc(q.value.trim()) + '». Prueba con la casa, la nota o el código V.</p>';

    }

    function abrir(){ ov.hidden = false; setTimeout(function(){ q.focus(); }, 50); pinta(); }

    function cerrar(){ ov.hidden = true; q.value = ''; }

    document.addEventListener('click', function(e){

      if(e.target.closest('[data-fb-abrir]')){ e.preventDefault(); abrir(); return; }

      if(e.target.closest('[data-fb-cerrar]') || e.target === ov){ cerrar(); return; }

      var it = e.target.closest('.fb-it');

      if(it && it.dataset.h){ location.href = '/products/' + it.dataset.h; }

    });

    q.addEventListener('input', pinta);
    q.addEventListener('keydown',function(e){if(e.key==='Enter'&&!e.isComposing){e.preventDefault();pinta();var b=res.querySelector('.fb-it[data-h]');if(b&&b.dataset.h)location.assign('/products/'+encodeURIComponent(b.dataset.h));}});

    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && !ov.hidden) cerrar(); });

  }

  /* El maestro compartido decide pertenencia; el proveedor vivo decide la venta.

     ficha-datos conserva únicamente anotaciones y relaciones editoriales por SKU. */

  function codigoCatalogo(s){

    var m=/^V0*(\d{1,4})(?:-(?:30|50|100))?$/.exec(String(s||'').trim().toUpperCase());

    return m ? 'V'+('000'+m[1]).slice(-Math.max(3,m[1].length)) : '';

  }

  function unirCatalogoFicha(anotaciones, maestro, comercial){

    if(!Array.isArray(maestro)||!comercial||!comercial.tallas)throw Error('Catálogo no disponible');

    var tallas=comercial.tallas, perfumes={},bolsillos={};

    (comercial.productos||[]).forEach(function(p){

      if(!p.onlineStoreUrl)return;

      ((p.variants||{}).nodes||[]).forEach(function(v){

        var s=codigoCatalogo(v.sku);

        if(s&&v.availableForSale&&/^30\s*ml$/i.test(v.title||'')&&/\d+$/.test(v.id||''))bolsillos[s]=String(v.id).split('/').pop();

      });

    });

    maestro.forEach(function(p){

      var s=codigoCatalogo(p.code);

      if(!s||p.kind!=='Fragancia'||perfumes[s])return;

      var op={};

      ['50','100'].forEach(function(size){

        var t=tallas[size]||{},id=(t.variantes||{})[s],price=(t.precios||{})[s];

        if(id&&/^\d+$/.test(String(id))&&price!==null&&price!==undefined&&Number.isFinite(Number(price))&&Number(price)>=0)op[size]=[Number(price),String(id),size+' ml'];

      });

      if(!Object.keys(op).length)return;

      var a=(anotaciones.perf||{})[s]||{},nombre=String(p.name||'').trim(),casa=String(p.house||'').trim();

      /* El maestro de Privé conserva algunos títulos Shopify y la casa de tienda;

         sólo esos placeholders usan la anotación editorial verificada. */

      if(!nombre||/^V\d+\s+(?:Inspiraci[oó]n|Inspirado)/i.test(nombre))nombre=a.n||nombre||s;

      if(!casa||/^Velantis$/i.test(casa))casa=a.c||casa;

      perfumes[s]=Object.assign({},a,{

        n:nombre,c:casa,cn:[a.cn||'',nombre].concat(p.alias||[]).join(' '),

        p:a.p||'',f:a.f||'',nt:a.nt||[],img:p.image||a.img||'',h:p.handle||'',

        o:op,b:bolsillos[s]||null

      });

    });

    return Object.assign({},anotaciones,{perf:perfumes});

  }

  function jsonCatalogo(url){

    if(!url)return Promise.reject(Error('Falta la fuente del catálogo'));

    return fetch(url).then(function(r){if(!r.ok)throw Error('Catálogo no disponible');return r.json();});

  }

  function cargarCatalogoFicha(){

    var nodo=document.getElementById('velantis-fuentes-catalogo'),fuentes={};

    try{fuentes=JSON.parse(nodo?nodo.textContent:'{}');}catch(e){return Promise.reject(e);}

    var mapa=window.MAPA_VIVO;

    if(!mapa||!mapa.comercial)return Promise.reject(Error('Conexión del catálogo no disponible'));

    return Promise.all([jsonCatalogo(pg.dataset.datos),jsonCatalogo(fuentes.maestro),mapa.comercial])

      .then(function(r){return unirCatalogoFicha(r[0],r[1],r[2]);});

  }


  /* R67: la ficha conserva sus relaciones editoriales; el título del aparato lo decide Shopify. */
  function sincronizarDifusores(D){
    var servicio=window.VelantisNombres;if(!servicio)return Promise.resolve(D);
    var carga=window.MAPA_VIVO&&window.MAPA_VIVO.comercial;
    if(carga)carga=carga.then(function(r){return r.productos;});
    else carga=Promise.all((D.dif||[]).map(function(x){
      if(!x.h)return null;
      var ctrl=window.AbortController?new AbortController():null,timer=ctrl?setTimeout(function(){ctrl.abort();},7000):null;
      return fetch('/products/'+encodeURIComponent(x.h)+'.js',ctrl?{signal:ctrl.signal}:{})
        .then(function(r){if(!r.ok)throw Error('Producto no disponible');return r.json();})
        .catch(function(){return null;}).finally(function(){if(timer)clearTimeout(timer);});
    }));
    return carga.then(function(ps){servicio.actualizar((ps||[]).filter(Boolean));return D;},function(){return D;})
      .then(function(datos){(datos.dif||[]).forEach(function(x){x.alias=x.n;x.n=servicio.nombre(x.n,null,x.h);});return datos;});
  }

  cargarCatalogoFicha().then(sincronizarDifusores).then(function(D){

    CDN = D.cdn || '';

    DATOS_F = D; pinta();

    proyeccion40(D);



    try{ sugerencia(D); }catch(e){ console.error('[ficha] sugerencia', e); }

    try{ piramideRespaldo(D); }catch(e){ console.error('[ficha] piramide', e); }

    abajo(D);
    resena45();

    try{ buscadorFicha(D); }catch(e){ console.error('[ficha] buscador', e); }

  }).catch(function(e){ console.error('[ficha] datos', e); pg.dataset.listo = 'sin-datos'; var meta=$('#ppPromoMeta');if(meta)meta.textContent='No pudimos cargar el catálogo. Recarga la página para volver a intentarlo.'; });

})();

